import { persistentMap } from "@nanostores/persistent"
import apiRequest from "@utils/apiRequest"
import filter from "lodash/filter"
import * as cookies from "tiny-cookie"

export type LikesValue = {
  recipes: string
  bundles: string
  collections: string
}

export const $likes = persistentMap<LikesValue>("likes:", {
  recipes: JSON.stringify([]),
  bundles: JSON.stringify([]),
  collections: JSON.stringify([]),
})

export const fetchLikes = async () => {
  try {
    const res = await apiRequest(`/v1/users/likes`, {
      token: cookies.get("token") ?? undefined,
    })
    const recipes = filter(res.data, (like) => like.recipe_id !== null).map((like) => like.recipe_id)
    const collections = filter(res.data, (like) => like.collection_id !== null).map((like) => like.collection_id)
    const bundles = filter(res.data, (like) => like.bundle_id !== null).map((like) => like.bundle_id)
    $likes.setKey("recipes", JSON.stringify(recipes))
    $likes.setKey("collections", JSON.stringify(collections))
    $likes.setKey("bundles", JSON.stringify(bundles))
  } catch (e) {
    console.error(e)
  }
}

export const checkLiked = (type: "r" | "b" | "c", id: number | null) => {
  if (!id) return false

  let likes = []
  if (type === "r") {
    likes = JSON.parse($likes.get().recipes ?? "[]")
    return likes.includes(id)
  } else if (type === "b") {
    likes = JSON.parse($likes.get().bundles ?? "[]")
    return likes.includes(id)
  } else if (type === "c") {
    likes = JSON.parse($likes.get().collections ?? "[]")
    return likes.includes(id)
  }
}

export const toggleLike = async (type: "r" | "b" | "c", id: number | null) => {
  if (!id) return false

  let likes = []
  if (type === "r") {
    likes = JSON.parse($likes.get().recipes ?? "[]")
  } else if (type === "b") {
    likes = JSON.parse($likes.get().bundles ?? "[]")
  } else if (type === "c") {
    likes = JSON.parse($likes.get().collections ?? "[]")
  }

  if (likes.includes(id)) {
    likes = likes.filter((like: number) => like !== id)
    if (cookies.get("token")) {
      await apiRequest(`/v1/likes/${id}?type=${type}`, { method: "DELETE", token: cookies.get("token") ?? undefined })
    }
  } else {
    likes.push(id)
    // add like to db
    let body = {}
    try {
      if (type === "r") {
        body = { recipeId: id }
      } else if (type === "c") {
        body = { collectionId: id }
      } else if (type === "b") {
        body = { bundleId: id }
      }
      await apiRequest(`/v1/likes`, {
        method: "POST",
        token: cookies.get("token") ?? undefined,
        body,
      })
    } catch (e) {
      console.error(e)
    }
  }

  if (type === "r") {
    $likes.setKey("recipes", JSON.stringify(likes))
  } else if (type === "b") {
    $likes.setKey("bundles", JSON.stringify(likes))
  } else if (type === "c") {
    $likes.setKey("collections", JSON.stringify(likes))
  }
}
